export default {
  DAY_NAMES: ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'],
  MONTHS: [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december',
  ],
};
